<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('studentScoringComponentEntry.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentScoringComponentEntry.pageTitle'),
            href: '/student-scoring-entries'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12">
            <ts-loading-banner :loading="loading">
              <filter-component
                v-model="model"
                :class-operations="classes"
                @acStatusChange="onStatusChange"
              />
            </ts-loading-banner>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <student-list
              v-model="model"
              :class-operations="classes"
              ref="studentlist"
            />
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import FilterComponent from './components/filter-component'
import { mapActions } from 'vuex'
import StudentList from './components/student-list'

export default {
  name: 'studentScoringComponentEntryCreate',
  components: {
    FilterComponent,
    StudentList
  },
  data () {
    return {
      loading: false,
      classes: [],
      classesByTeacher: [],
      model: {
        class_id: null, // add on param
        score_type: 1, // add on param but no use in DB
        st_class_id: null,
        acp_id: null,
        ac_year_id: null,
        ac_term_id: null,
        student_id: null,
        scoring_cycle_id: null,
        cycle_value: null,
        sc_subject_id: null,
        subject_id: null,
        sc_item_subject_comp_list: [
          {
            scoring_id: 0,
            sc_item_subject_comp_id: null,
            actual_score: null,
            max_score: null
          }
        ]
      }
    }
  },
  created () {
    this.fetchClass()
  },
  methods: {
    ...mapActions('studentScoringComponentEntry', [
      'getClassOperation',
      'getScoringCycle',
      'getScoringCycleValue',
      'getClassByTeacher'
    ]),
      async fetchClass() {
      this.loading = true

      await this.getScoringCycleValue()

      this.getClassByTeacher({
        branch_id: this.model.branch_id,
        ac_year_id: this.model.ac_year_id,
        acp_id: this.model.acp_id,
        ac_term_id: this.model.ac_term_id
      })
        .then(response => {
          this.classes = response.data || []
        })
        .catch(error => {
          this.$toasted.error(error.message || 'Failed to fetch classes')
        })
        .finally(() => {
          this.loading = false
        })
    },
    onStatusChange () {
      this.classes = []
      this.model.class_id = null // add on param
      this.model.score_type = 1 // add on param but no use in DB
      this.model.st_class_id = null
      this.model.acp_id = null
      this.model.ac_year_id = null
      this.model.ac_term_id = null
      this.model.student_id = null
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.model.sc_subject_id = null
      this.model.sc_item_subject_comp_list = [
        {
          scoring_id: 0,
          sc_item_subject_comp_id: null,
          actual_score: null,
          max_score: null
        }
      ]
      this.$refs.studentlist.student_list = []
      this.fetchClass()
    }
  }
}
</script>
